export const P2P_ORDER_DEEPLINK_ID = 'p2p-order-deeplink';
